import Typography from '../Atoms/Typography';
import { Icon } from '../Icons';
import PlanExpired from '../../assets/images/PlanExpired.svg';
import LimitExhausted from '../../assets/images/LimitExhausted.svg';
import hypertestFeature from '../../assets/images/onboarding/hypertest-feature.svg';
import tenPercentageThreshold from '../../assets/images/tenPercentageThreshold.svg';
import sixtyPercentageThreshold from '../../assets/images/sixtyPercentageThreshold.svg';
import ninetyPercentageThreshold from '../../assets/images/ninetyPercentageThreshold.svg';
import PlanAboutToExpire from '../../assets/images/PlanAboutToExpire.svg';
import {
  HYPERTEST_TRIAL_FEATURELIST,
  HYPERTEST_TRIAL_CUSTOM_FEATURELIST,
} from '../../utils/messages';
import { openZohoSalesIqChat } from '../../utils/common';

import { isEnterPressed } from 'utils/keyboard';
import useRemainingMinutes from 'hooks/useRemainingMinutes';

function TrialMainComponent({
  type,
  threshold,
  handleUpgradeClick,
  handleContactSaleClick,
  isCustomTrial,
  userPlan,
}) {
  const { kFormatedMinutes } = useRemainingMinutes();
  let featureList = isCustomTrial
    ? HYPERTEST_TRIAL_CUSTOM_FEATURELIST
    : HYPERTEST_TRIAL_FEATURELIST;
  let thresholdLimitImage = LimitExhausted;
  if (threshold === 10) {
    thresholdLimitImage = tenPercentageThreshold;
  }
  if (threshold === 60) {
    thresholdLimitImage = sixtyPercentageThreshold;
  }
  if (threshold === 90) {
    thresholdLimitImage = ninetyPercentageThreshold;
  }

  let bodyComponent = (
    <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between  ltw-px-40px">
      <Typography
        variant="h2"
        color="ltw-text-black"
        fontType="ltw-font-bold"
        fontSize="ltw-text-32"
        lineHeight="ltw-leading-33"
      >
        You’re currently on Trial
      </Typography>
      <Typography
        variant="h2"
        color="ltw-text-black-secondary-2"
        fontType="ltw-font-normal"
        fontSize="ltw-text-13"
        lineHeight="ltw-leading-19"
        align="center"
        mb="10px"
      >
        <Icon
          name={'thunder'}
          width="14"
          height="16"
          className="ltw-cursor-pointer ltw-inline-block ltw-my-6px"
        />
        Lightning fast Test Automation Cloud to speed up releases and cut down
        time to market without breaking the bank
      </Typography>
      <img
        src={hypertestFeature}
        width="321"
        height="229"
        alt="Hypertest Feature"
      />
      <div className="trial-list">
        {featureList.map((feature, index) => {
          return (
            <div className="ltw-flex ltw-items-center ltw-gap-5px" key={index}>
              <span className="ltw-h-5px ltw-w-5px ltw ltw-rounded-full ltw-inline-block ltw-bg-black ltw-mx-5px"></span>
              <Typography
                variant="h2"
                color="ltw-text-secondary"
                fontType="ltw-font-normal"
                fontSize="ltw-text-15"
                lineHeight="ltw-leading-30"
              >
                {index === 1
                  ? `Blazing fast testing for ${kFormatedMinutes} minutes`
                  : feature}
              </Typography>
            </div>
          );
        })}
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-20px">
          <button
            onClick={() => handleUpgradeClick('trial_popup')}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-9px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Upgrade Now
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick('trial_popup')}
            onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    </div>
  );
  if (type === 'PLAN_EXPIRED') {
    bodyComponent = (
      <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-10px ltw-px-40px ltw-py-10px">
        <img
          src={PlanExpired}
          width="415"
          height="327"
          alt="Hypertest Feature"
        />
        <Typography
          variant="h2"
          color="ltw-text-black"
          fontType="ltw-font-bold"
          fontSize="ltw-text-32"
          lineHeight="ltw-leading-33"
        >
          Your Plan has expired
        </Typography>
        <Typography
          variant="h2"
          color="ltw-text-black-secondary-2"
          fontType="ltw-font-normal"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-19"
          mb="25px"
          align="center"
        >
          Hope you’ve enjoyed the blazing fast testing!<br></br> Please renew or
          upgrade your Hyperexecute plan to continue.
        </Typography>
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-15px">
          <button
            onClick={() => handleUpgradeClick('plan_expired')}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-12px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Renew Subscription
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick('plan_expired')}
            onKeyDown={(e) => isEnterPressed(e) && openZohoSalesIqChat()}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    );
  }
  if (type === 'PAID_NINTY_PER_LIMIT_EXHAUSTED_THRESHOLD') {
    bodyComponent = (
      <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-10px ltw-px-40px ltw-py-10px">
        <img
          src={PlanAboutToExpire}
          width="415"
          height="327"
          alt="Hypertest Feature"
        />
        <Typography
          variant="h2"
          color="ltw-text-black"
          fontType="ltw-font-bold"
          fontSize="ltw-text-28"
          lineHeight="ltw-leading-33"
        >
          Your plan is about to expire
        </Typography>
        <Typography
          variant="h2"
          color="ltw-text-black-secondary-2"
          fontType="ltw-font-normal"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-19"
          mb="25px"
          align="center"
        >
          Hope you’re enjoying the blazing fast testing! <br></br> Please renew
          or upgrade your Hyperexecute plan now.
        </Typography>
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-15px">
          <button
            onClick={() => handleUpgradeClick('paid_plan_expired_ninty')}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-12px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Renew Subscription
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick('paid_plan_expired_ninty')}
            onKeyDown={(e) => isEnterPressed(e) && openZohoSalesIqChat()}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    );
  }
  if (type === 'PAID_PLAN_EXPIRED') {
    bodyComponent = (
      <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-10px ltw-px-40px ltw-py-10px">
        <img
          src={PlanExpired}
          width="415"
          height="327"
          alt="Hypertest Feature"
        />
        <Typography
          variant="h2"
          color="ltw-text-black"
          fontType="ltw-font-bold"
          fontSize="ltw-text-28"
          lineHeight="ltw-leading-33"
        >
          Your Current plan has expired
        </Typography>
        <Typography
          variant="h2"
          color="ltw-text-black-secondary-2"
          fontType="ltw-font-normal"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-19"
          mb="25px"
          align="center"
        >
          Hope you’ve enjoyed the blazing fast testing!<br></br> Please renew or
          upgrade your Hyperexecute plan to continue.
        </Typography>
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-15px">
          <button
            onClick={() => handleUpgradeClick('paid_plan_expired')}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-12px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Renew Subscription
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick('paid_plan_expired')}
            onKeyDown={(e) => isEnterPressed(e) && openZohoSalesIqChat()}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    );
  }
  if (type === 'LIMIT_EXHAUSTED_THRESHOLD') {
    bodyComponent = (
      <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-10px ltw-px-40px ltw-py-10px">
        <img
          src={thresholdLimitImage}
          width="458"
          height="339"
          alt="Hypertest Feature"
        />
        <Typography
          variant="h2"
          color="ltw-text-black"
          fontType="ltw-font-bold"
          fontSize="ltw-text-30"
          lineHeight="ltw-leading-33"
        >
          You've used {threshold}% of your limit
        </Typography>
        <Typography
          variant="h2"
          color="ltw-text-black-secondary-2"
          fontType="ltw-font-normal"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-19"
          mb="25px"
          align="center"
        >
          Hope you’re enjoying the blazing fast testing! <br></br> Please
          upgrade your Hyperexecute plan now.
        </Typography>
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-15px">
          <button
            onClick={() => handleUpgradeClick(`limit_exhausted_${threshold}`)}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-9px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Upgrade Now
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick(`limit_exhausted_${threshold}`)}
            onKeyDown={(e) => isEnterPressed(e) && openZohoSalesIqChat()}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    );
  }
  if (type === 'LIMIT_EXHAUSTED') {
    bodyComponent = (
      <div className="ltw-flex ltw-flex-col ltw-items-center ltw-justify-between ltw-gap-10px ltw-px-40px ltw-py-10px">
        <img
          src={LimitExhausted}
          width="458"
          height="339"
          alt="Hypertest Feature"
        />
        <Typography
          variant="h2"
          color="ltw-text-black"
          fontType="ltw-font-bold"
          fontSize="ltw-text-32"
          lineHeight="ltw-leading-33"
        >
          Your limit is exhausted
        </Typography>
        <Typography
          variant="h2"
          color="ltw-text-black-secondary-2"
          fontType="ltw-font-normal"
          fontSize="ltw-text-13"
          lineHeight="ltw-leading-19"
          mb="25px"
          align="center"
        >
          Hope you've enjoyed the trial run! <br></br> Please upgrade to a
          Hyperexecute plan to continue.
        </Typography>
        <div className="ltw-flex ltw-justify-center ltw-gap-20px ltw-mb-20px ltw-mt-15px">
          <button
            onClick={() => handleUpgradeClick('limit_exhausted')}
            // onKeyDown={openZohoSalesIqChat}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-gap-9px ltw-border ltw-border-primary ltw-bg-primary ltw-rounded ltw-px-20px ltw-py-16px"
          >
            <Typography
              variant="h2"
              color="ltw-text-white"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Upgrade Now
            </Typography>
            <Icon
              name={'right-arrow'}
              width="14"
              height="16"
              className="ltw-cursor-pointer"
            />
          </button>
          <button
            onClick={handleContactSaleClick('limit_exhausted')}
            onKeyDown={(e) => isEnterPressed(e) && openZohoSalesIqChat()}
            className="ltw-bg-transparent ltw-flex ltw-items-center ltw-border ltw-border-secondary ltw-rounded ltw-px-30px ltw-py-16px ltw-cursor-pointer"
          >
            <Typography
              variant="h2"
              color="ltw-text-secondary"
              fontSize="ltw-text-16"
              fontType="ltw-font-medium"
              lineHeight="ltw-leading-19"
              cursor="pointer"
            >
              Contact Sales
            </Typography>
          </button>
        </div>
      </div>
    );
  }
  // if (type === 'TRIAL_FEATURE') {
  //   bodyComponent = bodyComponent;
  // }
  return bodyComponent;
}
export default TrialMainComponent;
